import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { merge, of, Subscription } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { NotificationService } from 'src/app/core/common-services/notification.service';
import { UserService } from 'src/app/core/common-services/user.services';
import { InvestType } from 'src/app/core/data-models/KYC.data.models';
import { MenuDataService } from 'src/app/core/data-services/MenuData/menu-data.service';
import { NotificationDataService } from 'src/app/core/data-services/notification/notification-data.service';
import { LanguageService } from 'src/app/shared/services/language.service';


@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit, OnDestroy{
  @ViewChild('logoutTemplateRef') logoutTemplateRef!: TemplateRef<any>;

  private langChangeSub?: Subscription;
  investTypes=InvestType;
  menuItems: any[] = [];
  manageUsersExpanded: boolean = false;

  @Input() sidebarCollapsed: boolean = false;
  @Input() isRtl: boolean= false;
  @Input() isMobileView: boolean = false;
  @Output() collapseSidebar = new EventEmitter<void>();
  constructor(
    protected userService: UserService,
    private matDialog:MatDialog,
    public languageService:LanguageService,
    private responsive: BreakpointObserver,
    private notificationDataService:NotificationDataService,
    public notificationService:NotificationService,
      private menuService: MenuDataService,
      private translate: TranslateService,
  ){

  }
  ngOnDestroy(): void {
    this.langChangeSub?.unsubscribe();
  }

  private isArabicLanguage(lang: string | null | undefined): boolean {
    const normalized = String(lang || '').toLowerCase();
    return normalized === 'ar' || normalized.startsWith('ar-');
  }

  ngOnInit(): void {
    // Use the language service instead of direct localStorage access
    this.isRtl = this.isArabicLanguage(this.languageService.currentLanguage);
    this.checkMobileView();
    // One menu load on mount; reload only when language actually changes (avoids duplicate user-pages with init + onLangChange).
    const initialLang =
      this.translate.currentLang ||
      this.translate.defaultLang ||
      this.languageService.currentLanguage ||
      'en';
    this.langChangeSub = merge(
      of(initialLang),
      this.translate.onLangChange.pipe(map((e) => e.lang))
    )
      .pipe(distinctUntilChanged())
      .subscribe((lang) => {
        this.isRtl = this.isArabicLanguage(lang);
        this.loadMenu();
      });
    window.addEventListener('resize', () => this.checkMobileView());
    
    // Listen to language changes and update RTL
    window.addEventListener('storage', (e) => {
      if (e.key === 'currentLang') {
        this.isRtl = this.isArabicLanguage(e.newValue);
      }
    });
  }
 checkMobileView() {
    this.isMobileView = window.innerWidth <= 991;
  }
  loadMenu(): void {
    this.menuService.getUserMenu().subscribe({
      next: (res) => {
        if (res?.success) {
          const r = res.resource as { menuTree?: unknown[]; MenuTree?: unknown[] } | undefined;
          const raw = r?.menuTree ?? r?.MenuTree ?? [];
          this.menuItems = this.normalizeMenuTree(raw);
        }
      },
      error: (err) => console.error('Menu load error:', err)
    });
  }

  /** API may return camelCase or PascalCase; normalize for the template. */
  private normalizeMenuTree(items: unknown): unknown[] {
    if (!Array.isArray(items)) {
      return [];
    }
    return items.map((item: any) => {
      const children = item?.children ?? item?.Children;
      return {
        ...item,
        id: item?.id ?? item?.Id ?? '',
        title: item?.title ?? item?.Title ?? '',
        route: item?.route ?? item?.Route,
        icon: item?.icon ?? item?.Icon,
        expanded: item?.expanded ?? item?.Expanded ?? false,
        children: this.normalizeMenuTree(children),
      };
    });
  }

  collapseSide() {
    this.sidebarCollapsed = !this.sidebarCollapsed;
      this.collapseSidebar.emit();
  }
  
getPushNotificationsCount(){
  this.notificationDataService.GetUnreadNotificationsCount().subscribe({
    next:(res)=>{
      if(res&&res.data){
        // this.notificationService.unreadPushNotificationsCount=res.data.unreadNotificationsCount;
      }
    }
  })
}
  logOut() {
    this.closeLogoutDialog();
  }
  closeLogoutDialog(){
    this.matDialog.closeAll();
  }
  openLogoutDialog(){
    this.closeLogoutDialog();
    this.matDialog.open(this.logoutTemplateRef, {
      height: 'auto',
      width:'600px',
      panelClass:'dialog-class',
    });
  }

  closeMenu() {
    this.isMobileView = false;
  }
  toggleExpand(item: any) {
  item.expanded = !item.expanded;
}

  /** Role name(s) for the signed-in dashboard user (from login / JWT). */
  userRolesDisplay(): string {
    return this.userService.getDashboardRolesDisplay();
  }
}
